import { SimplifiedSuggestion } from '@gumtree/ui-library/src/utils/suggestions-service';

// Action type constant
export const UPDATE_ALTERNATIVE_SEARCH_SUGGESTIONS = 'UPDATE_ALTERNATIVE_SEARCH_SUGGESTIONS';

// Action creator
export const updateAlternativeSearchSuggestions = (payload: SimplifiedSuggestion[]) => ({
    type: UPDATE_ALTERNATIVE_SEARCH_SUGGESTIONS,
    payload,
});

// Reducer
export default function alternativeSearchSuggestions(
    state: SimplifiedSuggestion[] = [],
    action: ReturnType<typeof updateAlternativeSearchSuggestions>
) {
    return action.type === UPDATE_ALTERNATIVE_SEARCH_SUGGESTIONS ? action.payload : state;
}
